var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserFriendly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_534)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_60_534)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_60_534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.069 0.00266827C13.8246 -0.0270893 12.5868 0.192311 11.4285 0.647962C10.2701 1.10361 9.21456 1.78632 8.32393 2.65591C7.43329 3.5255 6.72555 4.56442 6.24234 5.71156C5.75913 6.8587 5.5102 8.09089 5.5102 9.33565C5.5102 10.5804 5.75913 11.8126 6.24234 12.9597C6.72555 14.1069 7.43329 15.1458 8.32393 16.0154C9.21456 16.885 10.2701 17.5677 11.4285 18.0233C12.5868 18.479 13.8246 18.6984 15.069 18.6686C16.3134 18.6984 17.5512 18.479 18.7096 18.0233C19.8679 17.5677 20.9235 16.885 21.8141 16.0154C22.7048 15.1458 23.4125 14.1069 23.8957 12.9597C24.3789 11.8126 24.6279 10.5804 24.6279 9.33565C24.6279 8.09089 24.3789 6.8587 23.8957 5.71156C23.4125 4.56442 22.7048 3.5255 21.8141 2.65591C20.9235 1.78632 19.8679 1.10361 18.7096 0.647962C17.5512 0.192311 16.3134 -0.0270893 15.069 0.00266827ZM9.73285 23.9995C7.25617 23.9995 4.88093 24.9833 3.12966 26.7346C1.37839 28.4859 0.394531 30.8611 0.394531 33.3378V40H29.7435V33.3378C29.7435 30.8611 28.7597 28.4859 27.0084 26.7346C25.2571 24.9833 22.8819 23.9995 20.4052 23.9995H9.73285Z",
    fill: "url(#paint0_linear_60_534)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_534",
    x1: 4.09347,
    y1: -24.6545,
    x2: 38.6655,
    y2: -19.4676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.394531)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_60_534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.394531)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_60_534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.394531)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFriendly);
export default __webpack_public_path__ + "static/media/user-friendly.c737fa95c224ac419aa17c10e9579507.svg";
export { ForwardRef as ReactComponent };